<div class="advanced-search-container flex-column">
  <app-input-search
    [searchQuery]="currentSearchText()"
    [placeholder]="searchPlaceHolder()"
    (searchEvent)="onSearch($event)"
  >
    @if (config().filters.length) {
      <mat-icon
        [matMenuTriggerFor]="filterMenu"
        [ngClass]="{
          'icon-20': true,
          'primary-color': isAnyFilterEnabled(),
          bold: isAnyFilterEnabled(),
        }"
        suffix-icon
      >
        filter_list
      </mat-icon>
    }
  </app-input-search>

  <mat-chip-grid>
    @for (filter of getEnabledSortedFilters(); track filter.label) {
      <mat-chip-row
        class="tag-chip"
        [ngClass]="'max-chars-37'"
        [removable]="true"
        (removed)="onRemoveFilter(filter)"
        [matMenuTriggerFor]="filterOptionsMenu"
        #filterOptionsMenuTriggers="matMenuTrigger"
      >
        <div class="container-flex">
          @let filterOptionsEnabled = getFilterOptionsEnabled(filter);
          <div
            (click)="onSelectFilter(filter)"
            [ngClass]="{
              text: true,
              bold: filter.label === selectedFilter()?.label,
            }"
          >
            <b>{{ filter.label }}</b>
            @if (filterOptionsEnabled.length === 1) {
              <span>: {{ filterOptionsEnabled[0].label }}</span>
            } @else {
              <span>&nbsp;({{ filterOptionsEnabled.length }})</span>
            }
          </div>
          <mat-icon
            matChipTrailingIcon
            class="no-padding clickable"
            (click)="onSelectFilter(filter)"
          >
            arrow_drop_down
          </mat-icon>
          <mat-icon matChipRemove class="remove-icon" [tp]="translations.remove" [tpIsLazy]="true">
            cancel
          </mat-icon>
        </div>
      </mat-chip-row>
    }
  </mat-chip-grid>

  <mat-menu
    #filterMenu="matMenu"
    xPosition="before"
    yPosition="below"
    class="dropdown-menu advanced-search-filter-mat-menu"
  >
    <app-dropdown-menu>
      @if (areAllFiltersEnabled()) {
        <app-dropdown-menu-item [disabled]="true">
          <ng-container i18n="@@shared.nomorefiltersavailable">
            No more filters available
          </ng-container>
        </app-dropdown-menu-item>
      } @else {
        @for (filter of config().filters; track filter.label) {
          @if (!filter.enabled) {
            <app-dropdown-menu-item (pressed)="onAddFilter(filter)">
              {{ filter.label }}
            </app-dropdown-menu-item>
          }
        }
      }
    </app-dropdown-menu>
  </mat-menu>

  <mat-menu
    #filterOptionsMenu="matMenu"
    yPosition="below"
    class="dropdown-menu advanced-search-mat-menu"
    (closed)="selectedFilter.set(undefined)"
  >
    @if (selectedFilter()?.optionsFormGroup) {
      <div class="full-width" [formGroup]="selectedFilter().optionsFormGroup">
        <app-input-chips
          #inputChips
          [class]="'no-padding'"
          formControlName="options"
          [placeholder]="translations.search"
          [options]="selectedFilter().options"
          [isShowHint]="false"
          [isShowOptionsInline]="true"
          [isShowOptionsEvenIfSelected]="true"
          [isGetTagsFromForm]="true"
          (tagSelected)="onToggleFilterOption($event)"
          (tagDeselected)="onToggleFilterOption($event)"
        ></app-input-chips>
      </div>
    }
  </mat-menu>
</div>
